import { useContext } from 'react';
import { ScheduleAndDispatchContext } from '../Contexts/ScheduleAndDispatchContext';
export default function useScheduleAndDispatchContext() {
    const context = useContext(ScheduleAndDispatchContext);
    if (!context) {
        throw new Error('useScheduleAndDispatchContext must be used within a ScheduleAndDispatchProvider');
    }
    return context;
}
